/** Api url from app config.json*/
export const api_url = 'api';

export const appConst = {
  ImageMaxLimit: 4,
  VideoMaxLimit: 3,
  GoodMrgMsg: 'Good Morning!',
  GoodNoonMsg: 'Good Afternoon!',
  GoodEveMsg: 'Good Evening!',
};

/** uploaded file type and max size Validation */
export const allowedFileForImage: string[] = ['.jpg', '.jpeg', '.png', '.svg'];
export const allowedFileFormatForImageandIcons: string[] = [
  '.jpg',
  '.jpeg',
  '.png',
  '.svg',
];
export const allowedFileFormatForVideo: string[] = ['.mp4', '.webm'];

export const maxSizeInBytesImage: number = 1048576; //1MB
export const maxSizeInBytesVideo: number = 2097152; //5MB

// Encryption key for AES-256-GCM encryption for UAT - com.lnw.viejaslabviejas
// Encryption key for AES-256-GCM encryption for DEV - com.lnw.ViejasDemoviejascasino
export const encryptionKey = 'com.qlx.myviejasviejas'; 

export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; 

export const HERO_CLUB_ID = '49';

/** Idle Timeout Configuration (in minutes) */
export const idleTimeoutConfig = {
  idleTime: 60,            // Main idle timer (1 minute for testing, 60 for production)
  warningTime: 2,         // Warning dialog duration (2 minutes)
  checkInterval: 15,      // Token validation check interval (15 minutes)
  activityDebounce: 1000, // Debounce activity events (1 second)
}; 
